import axios from 'axios'

const client = axios.create()

client.interceptors.response.use(
	function (response) {
		return response
	},
	function (error) {
		console.log(error)
		return Promise.reject(error)
	}
)

export default client